import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from '../../styles/LessonView.module.css';
export function ExplanationPanel({ text, analogy }) {
    return (_jsxs("div", { children: [_jsx("div", { className: styles.explanation, children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: {
                        table: ({ children }) => (_jsx("div", { className: styles.tableWrapper, children: _jsx("table", { children: children }) })),
                    }, children: text }) }), analogy && (_jsxs("div", { className: styles.analogy, children: [_jsx("div", { className: styles.analogyLabel, children: "\uD83D\uDCA1 \u0410\u043D\u0430\u043B\u043E\u0433\u0438\u044F" }), analogy] }))] }));
}
